import React from "react";

type OpenUrlButtonProps = {
  url: string;
    label: string;
};


const OpenUrlButton: React.FC<OpenUrlButtonProps> = ({ label,url }) => {
  const handleClick = () => {
    window.open(url, "_blank"); // Öppnar i ny flik
  };

  return (
    <button onClick={handleClick} /*style={{ padding: "10px 20px", cursor: "pointer" }}*/>
      {label}
    </button>
  );
};

export default OpenUrlButton;